// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `._dog_{display:flex;align-items:center;justify-content:center;block-size:64px;margin-block-start:-64px}._dog_ .W0lYu{display:flex;align-items:center;justify-content:center;inline-size:40px;block-size:40px;pointer-events:none;opacity:calc(var(--page-pull-distance, 0) / 64);transform:scale(clamp(0.5, calc(0.5 + var(--page-pull-distance, 0) / 128), 1));will-change:transform,opacity}._dog_ .W0lYu .lCZut{display:flex;transform:rotate(calc(var(--page-pull-distance, 0) / 64 * 270deg))}._dog_ .W0lYu .MnlB1{animation:none}._dog_ .W0lYu.ujOJw{opacity:1;transform:none}._dog_ .W0lYu.ujOJw .lCZut{animation:UaZEA .9s linear infinite;transform:none;will-change:transform;backface-visibility:hidden}@keyframes UaZEA{to{transform:rotate(360deg)}}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `_dog_`,
	"indicator": `W0lYu`,
	"spinner": `lCZut`,
	"loader": `MnlB1`,
	"refreshing": `ujOJw`,
	"spin": `UaZEA`
};
export default ___CSS_LOADER_EXPORT___;
